import { useMemo } from "react";

import DownloadButtonMenu from "app/components/React/DownloadButtonMenu/DownloadButtonMenu";
import type { BenchmarkGranularity } from "app/pages/benchmark-tracker/services/api/constants";
import DurationService from "app/services/DurationService";

import { getExcelDownloadUrl } from "./helpers";
import * as SC from "./styles";

type DownloadExcelDropdownSchema = {
    benchmarkId: string;
    granularity: BenchmarkGranularity;
    duration: string;
    totalCount: number;
    country: string;
};

export const DownloadExcelDropdown = ({
    benchmarkId,
    granularity,
    duration,
    totalCount,
    country,
}: DownloadExcelDropdownSchema) => {
    const formattedDuration = useMemo(() => DurationService.getDurationData(duration).forAPI.iso.from, [duration]);
    const downloadUrl = getExcelDownloadUrl({ country, formattedDuration, granularity, benchmarkId });

    return (
        <SC.PopupContainer>
            <DownloadButtonMenu
                Excel
                PaidExcel
                totalCount={totalCount}
                downloadUrl={downloadUrl}
            />
        </SC.PopupContainer>
    );
};
